import { Pagination } from "@mui/material"
import { useState } from "react";




export const PaginationCm=(setPage,change)=>{

  const [pagination, setPagination] = useState({ page: 1, total: 1 });
  const handleChange = (event, value) => {
    let da={ ...pagination,
        page: value}
    change({...da})
    setPagination({
        ...da
    });
  };
  return (
        <Pagination
        count={pagination.total}
        page={pagination.page}
        onChange={handleChange}
        sx={{ marginBottom: { xs: 2 } }}
      />
    )
}